import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const EligibleAdyenCountriesPayoutsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="To start receiving payments, you’ll need to connect a bank account to your Faire account. Here’s how you can do that:"
          description={{
            img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate your <LinkFormatting>Account Settings</LinkFormatting>."
              values={{
                LinkFormatting: (chunks: JSX.Element) =>
                  PayoutsLinkFormatting(chunks, "my-account"),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Go to the <LinkPayoutFormatting>Payouts</LinkPayoutFormatting> tab."
              values={{
                LinkPayoutFormatting: (chunks: JSX.Element) =>
                  PayoutsLinkFormatting(chunks, "payment"),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Click on <BoldFormatting>Complete Payout Information</BoldFormatting>."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="You will then be redirected to Adyen to complete your account setup."
              description={{
                img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Your payouts will not be initiated until your bank account is verified by Adyen. Payouts will then be issued according to the payout schedule you choose in your account settings."
          description={{
            img: "https://cdn.faire.com/fastly/48a5191f60ac4a585ff60d2e2c8eb761bc379ee7b285924a3f2b724976972245.png",
          }}
        />
      </Typography>
    </Column>
  );
};

const PayoutsLinkFormatting = (chunks: JSX.Element, tab: string) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalAccountRoute({ tab })}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
